import React, { useRef } from 'react';
import { connect } from 'react-redux';
import {
	setSpeechStatus,
	setShowEcho,
} from '../../redux/utilities/utils.actions';
import { toggleMicPermission } from '../../redux/testPage/testPage.actions';
import { recordAudio, sleep, isIos } from '../../utils/commonFunctions';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';

const EchoTest = ({ setSpeechStatus, setShowEcho, showEcho }) => {
	let audio = {};
	const isMounted = useRef(true);

	const retryRecording = () => {
		if (Object.keys(audio).length > 0) audio.pause();
		document.getElementById('beforeStartDiv').style.display = 'block';
		document.getElementById('afterStartDiv').style.display = 'none';
	};

	const handleAction = async () => {
		isMounted.current = true;
		const recorder = await recordAudio();

		recorder.start();
		document.getElementById('beforeStartDiv').style.display = 'none';
		document.getElementById('whileRecordingDiv').style.display = 'block';
		await sleep(6000);
		audio = await recorder.stop();
		if (isMounted.current) {
			document.getElementById('whileRecordingDiv').style.display = 'none';
			document.getElementById('afterStartDiv').style.display = 'block';
			if (isIos()) document.getElementById('echoTestAudio').src = audio.audioUrl;
			else audio.play();
		}
	};

	const setSpeechActive = () => {
		toggleMicPermission(true);
		setSpeechStatus();
	};

	const cleanUp = () => {
		isMounted.current = false;
		document.getElementById('whileRecordingDiv').style.display = 'none';
		retryRecording();
		setShowEcho(false);
	};

	return (
		<Modal
			show={showEcho}
			dialogClassName="modal-90w"
			onHide={cleanUp}
			backdrop="static"
			keyboard={false}
			style={{ minWidth: '300px' }}
		>
			<Modal.Header closeButton style={{ minWidth: '300px' }}></Modal.Header>
			<Modal.Body size="lg" className="text-center" style={{ minWidth: '300px' }}>
				<div id="beforeStartDiv">
					<img
						src="https://img.icons8.com/dotty/80/000000/microphone.png"
						alt="mic"
					/>

					<p>
						Please make sure your microphone is plugged in and allow your broswer to
						access your microphone and camera when prompted.
					</p>
					<p>Then, click start and speak few words. </p>
					<Button
						aria-label="Start"
						id="testMic"
						className="btn btn-lg btn-info go-next"
						onClick={() => handleAction()}
					>
						Start
					</Button>
				</div>

				<div style={{ display: 'none' }} id="whileRecordingDiv">
					<img
						src="https://img.icons8.com/ios/100/000000/listening--v2.png"
						alt="listening"
					/>
					<h6>
						<span className="test_message">Listening for audio</span>
						<div className="spinner">
							<div className="bounce1"></div>
							<div className="bounce2"></div>
							<div className="bounce3"></div>
						</div>
					</h6>
				</div>

				<div style={{ display: 'none' }} id="afterStartDiv">
					<p>
						If you could hear your recorded audio please select 'Yes'. Else select
						'No' to try again
					</p>
					{isIos() ? (
						<audio controls className="block-center">
							<source src="" type="audio/mpeg" id="echoTestAudio" />
							Your browser does not support the audio element.
						</audio>
					) : null}
					<button
						aria-label="yes"
						style={{ margin: '10px' }}
						data-dismiss="modal"
						onClick={() => setSpeechActive()}
						className="btn btn-lg btn-success"
					>
						<i className="fa fa-check-circle"></i> YES
					</button>
					<button
						aria-label="no"
						style={{ margin: '10px' }}
						onClick={() => retryRecording()}
						className="btn btn-lg btn-danger"
					>
						<i className="fa fa-times-circle"></i> NO
					</button>
				</div>
			</Modal.Body>
		</Modal>
	);
};

const mapStateToProps = (state) => {
	const { showEcho } = state.rootReducer.utils;
	return {
		showEcho,
	};
};
const mapDispatchToProps = (dispatch) => {
	return {
		setShowEcho: (val) => dispatch(setShowEcho(val)),
		setSpeechStatus: () => dispatch(setSpeechStatus()),
		toggleMicPermission: (val) => dispatch(toggleMicPermission(val)),
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(EchoTest);
